import PropTypes from "prop-types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Card, Icon, Title, TopSection } from "./Card.Style";
import gist_v from "../../../../assets/gi/gist_v.svg";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";

const doctorConsult = "/DoctorMedications.svg";

export default function MedicinesChanges() {
  const { t } = useTranslation();
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();
  const {
    bloodThinners,
    diabetesMedicines,
    nutritionalSupplement,
    colonoscopyBefore,
  } = event?.Case?.GiCase || {};

  // Order matters: items render in this sequence when "Yes" was answered.
  // bloodPressureMedicines is intentionally excluded per product requirements.
  const Questionnaires = {
    diabetesMedicines,
    bloodThinners,
    nutritionalSupplement,
    colonoscopyBefore,
  };

  const isYes = (val) => val === true || val === "Yes";
  const yesAnswers = Object.entries(Questionnaires)
    .filter(([, answerKey]) => isYes(answerKey))
    .map(([questionKey]) => questionKey);

  return (
    <Container show={yesAnswers.length > 0}>
      <TopContent>
        <IconWrapper>
          <Icon src={doctorConsult} alt="doctor" />
        </IconWrapper>
        <CardTitle>
          {t("MedicinesChanges-Title")}
        </CardTitle>
      </TopContent>
      <ListContainer>
        {yesAnswers.map((answer) => (
          <ListItem key={answer}>
            {t(`MedicinesChanges-${answer}`)}
          </ListItem>
        ))}
      </ListContainer>
    </Container>
  );
}

MedicinesChanges.propTypes = {
  show: PropTypes.bool,
};

const Container = styled(Card)`
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
  margin-inline: var(--screen-margin);
  border: none;
  border-radius: 20px;
  padding-inline: 28px;
  padding-block: 30px;
  background-color: #ffffff;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.06);
`;
const ListContainer = styled.ul`
  padding-inline-start: 1.5rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;
const ListItem = styled.li`
  font-family: "Abraham", sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  color: #1a1a1a;
  line-height: 1.5;
  padding-inline-start: 0.5rem;
  list-style-image: url("${gist_v}");
`;
const TopContent = styled(TopSection)`
  margin-block-end: 1.75rem;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: #ededf8;
`;
const CardTitle = styled(Title)`
  font-weight: bold;
  font-family: "Abraham", sans-serif;
  font-size: 1.375rem;
  color: #1a1a1a;
  line-height: 1.4;
`;
